import {useState} from 'react'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import toastr from 'toastr';
import clsx from 'clsx'
import { projectAPI } from '../../../api';

import {Modal} from '../../../components/Modal'

interface Props {
  project: any
  show: boolean
  handleClose: () => void
  handleUpdated: () => void
}

const schema = Yup.object().shape({
  name: Yup.string().required('Required'),
});

const APIAccessEditModal : React.FC<Props> = ({project, show, handleClose, handleUpdated}) => {

  const [handling, setHandling] = useState(false)

  const formik = useFormik({
    initialValues: {'name': project.name, 'description': project.description},
    validationSchema: schema,
    onSubmit: async (values) => {
      setHandling(true)
      try{
        await projectAPI.update(project.id, values)
        formik.resetForm()
        handleUpdated()
        handleClose()
      } finally {
        setHandling(false)
      }
    }
  })

  return <Modal show={show} handleClose={handleClose} dialogClassName="" title={'Edit API Access'}>
    <form
      className='form fv-plugins-bootstrap5 fv-plugins-framework'
      onSubmit={formik.handleSubmit}
      noValidate
    >
      <div className='fv-row mb-5 form-floating'>
        <input 
          placeholder="name"
          {...formik.getFieldProps('name')}
          className={clsx(
            'form-control bg-transparent h-60px border border-gray-400',
            {'is-invalid': formik.touched.name && formik.errors.name},
            {
              'is-valid': formik.touched.name && !formik.errors.name,
            }
          )}
          type='text'
          name='name'
        />
        <label className='form-label fs-6 text-gray-600'>Name</label>
      </div>
      <div className='fv-row mb-5 form-floating'>
        <input 
          placeholder="description"
          {...formik.getFieldProps('description')}
          className={clsx(
            'form-control bg-transparent h-60px border border-gray-400',
            {'is-invalid': formik.touched.description && formik.errors.description},
            {
              'is-valid': formik.touched.description && !formik.errors.description,
            }
          )}
          type='text'
          name='description'
        />
        <label className='form-label fs-6 text-gray-600'>description</label>
      </div>
      <div className="text-center">
        <button
          type='submit'
          className="btn btn-primary"
          disabled={handling || !formik.isValid}
        >
          {!handling && <span className='indicator-label'>Update</span>}
          {handling && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
        
        <button type="button" className="btn btn-light ms-3" onClick={handleClose}>
          Close
        </button>
      </div>
    </form>
  </Modal>
}

export {APIAccessEditModal}